var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLive)?_c('div',{ref:"playWndBox",staticClass:"videoMain",style:({width:_vm.setWidth,height:_vm.setHeight})},[_c('div',{ref:"play",staticClass:"play",attrs:{"id":"play"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }